import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const chirpPad: ProjectContentData = {
  id: 'chirppad',
  tabs: [
    {
      id: 'description',
      label: '',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
  ],
  hideTabs: true,
};
